<ng-container >
  <nav>
    <ol class="breadcrumb box-style">
      <li [routerLink]="routePath" class="breadcrumb-item"aria-current="page" *ngIf="title">{{title | translate}}</li>
      <li [routerLink]="routePath2" class="breadcrumb-item" *ngIf="title2">{{title2 | translate}} {{typeInfo2 | translate}}</li>
      <li (click)="Back()" class="breadcrumb-item" *ngIf="backPath">{{backPath | translate}} {{backPathInfo | translate}}</li>
      <li [routerLink]="routePath3" class="breadcrumb-item " [ngClass]="title4 ? '' : 'active'" aria-current="page" *ngIf="title3"><span>{{title3 | translate}} {{type | translate}} {{typeInfo3 | translate}}</span></li>
        <li *ngIf="title4" aria-current="page" class="breadcrumb-item active"><span>{{title4 | translate}} {{type2 | translate}} {{typeInfo4 | translate}}</span></li>
        <li *ngIf="title5" aria-current="page" class="breadcrumb-item active"><span>{{title5}}</span></li>
    </ol>
  </nav>
</ng-container>


